<template>
  <mdb-container>
    <div class="spinner-border" role="status" v-if="loading">
      <span class="sr-only">Loading...</span>
    </div>
    <div v-if="error">
      <error :error="error"/>
    </div>
    <div v-if="group">
      <banner-small :group="group"/>
    </div>
    <h3>Reviews</h3>
    <div v-if="count == 0">
      No reviews yet.
    </div>
    <section class="text-center my-5" v-if="count > 0">

      <mdb-carousel
        multi
        slide
        :items="count"
        testimonial
        indicators
        indicatorsColor="indigo"
        controlls
        navColor="indigo"
      >
        <template #[i+1] v-for="(testimonial, i) in testimonials">
          <mdb-testimonial :key="i">
            <mdb-avatar
              wrapperClass="z-depth-1 mb-4"
              :width="200"
              circle
              tag="img"
              :src="testimonial.img"
            />

            <h4 class="font-weight-bold mt-4">{{testimonial.name}}</h4>
            <h6 class="blue-text font-weight-bold my-3">{{testimonial.position}}</h6>
            <p class="font-weight-normal">
              <mdb-icon icon="quote-left" class="pr-2"></mdb-icon>
              {{testimonial.quote}}
            </p>
            <div>
              <mdb-rating :value="testimonial.rating" disabled far iconActiveClass="grey-text" />
            </div>
          </mdb-testimonial>
        </template>
      </mdb-carousel>
    </section>
  </mdb-container>
</template>

<script>
  import api from '../../services/groupsPlaceApi.js'
  import {mdbAvatar, mdbCarousel, mdbContainer, mdbIcon, mdbRating, mdbRow, mdbTestimonial} from 'mdbvue';
  import bannerSmall from "./BannerSmall"
  import error from "../common/Error"

  export default {
        name: 'Reviews',
        components: {
            mdbCarousel,
            mdbRating,
            mdbContainer,
            mdbRow,
            mdbTestimonial,
            mdbAvatar,
            mdbIcon,
            bannerSmall,
            error
        },
        data() {
            return {
                group: null,
                error: null,
                testimonials: [],
                loading: true,
                count: 0
            }
        },
        mounted() {
            this.loadPage()
        },
        methods: {
            loadPage: function () {
                this.refreshing = true
                api.get("/group/review/" + this.$route.params.id).then(
                (details) => {
                    this.group = details.data.group
                    this.testimonials = details.data.reviewData.reviews
                    this.count = this.testimonials.length
                },
                (error) => {
                    this.error = error
                }).
                finally( () => {
                    this.loading = false
                })
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @media screen and (max-width: 749px ) {
    .group-overlay-container {
      font-size: 175%;
      width: 84%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-right: 1.75em;
    }
  }

  @media screen and (min-width: 750px ) {
    .group-overlay-container {
      font-size: 250%;
      margin-left: 2.5em;
      margin-bottom: 30px;
    }

  }

  .group-banner {
    display: block;
    width: 100%;
    background-size: cover;
    padding-top: 25%;
    position: relative;
  }

  .group-overlay-container {
    background-color: #ffffff;
    opacity: 0.8;
    position: absolute;
    bottom: 0;
    padding-left: 10px;
    padding-right: 10px;
  }

  .group-overlay-name a {
    color: #362f2d;
    opacity: 1;
  }


</style>
